function calcDiscountPrice(currentPrice, retailValue) {
  let discount = (1 - currentPrice / retailValue) * 100;
  return parseInt(discount);
}

export {calcDiscountPrice}